export default __webpack_public_path__ + "31892082f591d41eed9f91dd4689f7ef.png";